'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.SkeletonShape = SkeletonShape;
exports.SkeletonText = SkeletonText;
exports.SkeletonButton = SkeletonButton;
exports.SkeletonAvatar = SkeletonAvatar;
exports.SkeletonPaper = SkeletonPaper;
exports.SkeletonCard = SkeletonCard;
exports.SkeletonListItem = SkeletonListItem;
exports.SkeletonGrid = SkeletonGrid;
exports.SkeletonList = SkeletonList;
exports.SkeletonPage = SkeletonPage;
exports.SkeletonPageHeader = SkeletonPageHeader;
exports.SkeletonPageHeaderHeading = SkeletonPageHeaderHeading;
exports.SkeletonPageHeaderToolbar = SkeletonPageHeaderToolbar;
exports.SkeletonPageHeaderTabs = SkeletonPageHeaderTabs;
exports.SkeletonContent = SkeletonContent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../layout');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _skeleton = require('./skeleton.css');

var _skeleton2 = _interopRequireDefault(_skeleton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Multiplier for textual content "size" */
var TEXT_SIZE_MULTIPLIER = 10;

/** Multiplier for an avatar diameter */
var AVATAR_SIZE_MULTIPLIER = 20;

/** Height of text */
var TEXT_HEIGHT = 12;

/** Height of a button */
var BUTTON_HEIGHT = 36;

/** A box which can space it's children */
function SpacerBox(_ref) {
  var _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === undefined ? 25 : _ref$spacing,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === undefined ? false : _ref$vertical,
      _ref$center = _ref.center,
      center = _ref$center === undefined ? true : _ref$center,
      childFlex = _ref.childFlex,
      children = _ref.children,
      styleProps = (0, _objectWithoutProperties3.default)(_ref, ['spacing', 'vertical', 'center', 'childFlex', 'children']);

  var alignItems = center ? 'center' : 'stretch';
  var style = vertical ? { alignItems: alignItems, marginTop: -spacing } : { flexDirection: 'row', alignItems: alignItems, marginLeft: -spacing };

  return _react2.default.createElement(
    _layout.Box,
    (0, _extends3.default)({}, style, styleProps),
    _react2.default.Children.map(children, function (child) {
      return _react2.default.createElement(
        _layout.Box,
        {
          marginTop: vertical ? spacing : 0,
          marginLeft: !vertical ? spacing : 0,
          flex: childFlex
        },
        child
      );
    })
  );
}

/** Skeleton representation of any arbitrary rectangular or circular shape */
function SkeletonShape(_ref2) {
  var _cx;

  var _ref2$shape = _ref2.shape,
      shape = _ref2$shape === undefined ? 'rect' : _ref2$shape,
      styleProps = (0, _objectWithoutProperties3.default)(_ref2, ['shape']);

  return _react2.default.createElement(_layout.Box, (0, _extends3.default)({
    className: (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _skeleton2.default.circle, shape === 'circle'), (0, _defineProperty3.default)(_cx, _skeleton2.default.shape, true), _cx))
  }, styleProps));
}

/**
 * Skeleton representation of text content
 * TODO: Allow multiline (with appropriate line spacing)
 */
function SkeletonText(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === undefined ? 7 : _ref3$size,
      _ref3$heading = _ref3.heading,
      heading = _ref3$heading === undefined ? false : _ref3$heading;

  var width = size * TEXT_SIZE_MULTIPLIER;
  var height = heading ? TEXT_HEIGHT * 2 : TEXT_HEIGHT;
  return _react2.default.createElement(SkeletonShape, { height: height, width: width });
}

/** Skeleton representation of a button */
function SkeletonButton(_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === undefined ? 7 : _ref4$size,
      square = _ref4.square;

  var width = square ? BUTTON_HEIGHT : size * TEXT_SIZE_MULTIPLIER;
  return _react2.default.createElement(SkeletonShape, { height: BUTTON_HEIGHT, width: width });
}

/** Skeleton representation of an avatar */
function SkeletonAvatar(_ref5) {
  var _ref5$size = _ref5.size,
      size = _ref5$size === undefined ? 4 : _ref5$size;

  var width = size * AVATAR_SIZE_MULTIPLIER;
  return _react2.default.createElement(SkeletonShape, { shape: 'circle', height: width, width: width });
}

/** Skeleton representation of paper container */
function SkeletonPaper(_ref6) {
  var children = _ref6.children,
      style = _ref6.style;

  return _react2.default.createElement(
    _layout.Box,
    { className: _skeleton2.default.paper, padding: 15, style: style },
    children
  );
}

/** Skeleton representation of an avatar */
function SkeletonCard(_ref7) {
  var children = _ref7.children;

  return _react2.default.createElement(
    _layout.Box,
    { className: _skeleton2.default.paper, paddingTop: 75, paddingBottom: 150 },
    _react2.default.createElement(
      SpacerBox,
      { vertical: true },
      children ? children : [_react2.default.createElement(SkeletonAvatar, { key: 'avatar' }), _react2.default.createElement(SkeletonText, { key: 'text' }), _react2.default.createElement(SkeletonText, { key: 'text-2', size: 14 })]
    )
  );
}

/** Skeleton representation of an avatar */
function SkeletonListItem(_ref8) {
  var children = _ref8.children;

  return _react2.default.createElement(
    _layout.Box,
    {
      className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _skeleton2.default.paper, true)),
      padding: 25
    },
    _react2.default.createElement(
      SpacerBox,
      null,
      children ? children : [_react2.default.createElement(SkeletonText, { size: 14, key: 0 }), _react2.default.createElement(SkeletonText, { key: 1 })]
    )
  );
}

/** Single row horizontal grid skeleton component */
function SkeletonGrid(_ref9) {
  var children = _ref9.children,
      center = _ref9.center;

  return _react2.default.createElement(
    SpacerBox,
    { childFlex: 1, center: center },
    children
  );
}

/** Vertical list layout skeleton component */
function SkeletonList(_ref10) {
  var children = _ref10.children,
      center = _ref10.center;

  return _react2.default.createElement(
    SpacerBox,
    {
      vertical: true,
      spacing: 10,
      alignItems: 'stretch',
      center: center
    },
    children
  );
}

/** Skeleton page */
function SkeletonPage(_ref11) {
  var children = _ref11.children,
      _ref11$width = _ref11.width,
      width = _ref11$width === undefined ? 1180 : _ref11$width;

  return _react2.default.createElement(
    _layout.Box,
    null,
    _react2.default.createElement(
      _layout.Box,
      { margin: [50, 'auto'], width: width },
      children
    )
  );
}

/** Skeleton page header */
function SkeletonPageHeader(_ref12) {
  var children = _ref12.children;

  return _react2.default.createElement(
    _layout.Box,
    {
      className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _skeleton2.default.header, true))
    },
    children
  );
}

/** Skeleton page header heading */
function SkeletonPageHeaderHeading(_ref13) {
  var _ref13$width = _ref13.width,
      width = _ref13$width === undefined ? 1180 : _ref13$width,
      children = _ref13.children;

  return _react2.default.createElement(
    _layout.Box,
    {
      margin: [0, 'auto'],
      width: width,
      height: 80,
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center'
    },
    children
  );
}

/** Skeleton page header heading */
function SkeletonPageHeaderToolbar(_ref14) {
  var _ref14$width = _ref14.width,
      width = _ref14$width === undefined ? 1180 : _ref14$width,
      children = _ref14.children;

  return _react2.default.createElement(
    _layout.Box,
    {
      className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _skeleton2.default.toolbar, true))
    },
    _react2.default.createElement(
      _layout.Box,
      { margin: [0, 'auto'], width: width },
      _react2.default.createElement(
        SpacerBox,
        { height: 46 },
        children
      )
    )
  );
}

/** Skeleton page header heading */
function SkeletonPageHeaderTabs(_ref15) {
  var _ref15$width = _ref15.width,
      width = _ref15$width === undefined ? 1180 : _ref15$width,
      children = _ref15.children;

  return _react2.default.createElement(
    _layout.Box,
    { margin: [0, 'auto'], width: width },
    _react2.default.createElement(
      SpacerBox,
      { height: 46 },
      children
    )
  );
}

/** Generic content */
function SkeletonContent(_ref16) {
  var children = _ref16.children;

  return _react2.default.createElement(
    _layout.Box,
    { padding: 15 },
    children
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/skeleton/skeleton.js
// module id = 353
// module chunks = 114276838955818